import { get } from 'lodash';
import { ProcedureValidationTypes } from '../enums/procedureValidationTypes';
import { ServiceCode } from '../enums/serviceCode';

export type AddOrEditType =
    | 'addProcedure'
    | 'addProcedureDiagnosticReport'
    | 'addProcedureDiagnosticReportWithRequest'
    | 'addProcedureWithRequest'
    | 'editProcedure'
    | 'editProcedureDiagnosticReport'
    | 'editProcedureDiagnosticReportWithRequest'
    | 'editProcedureWithRequest';

type DraftOrFinalType = 'draft' | 'final';

type ProcedureValidationTypesPerServiceCode = {
    [key1 in ServiceCode]?: {
        [key2 in AddOrEditType]?: {
            [key3 in DraftOrFinalType]?: {
                [key: number]: ProcedureValidationTypes;
            };
        };
    };
};

const procedureValidationTypes: ProcedureValidationTypesPerServiceCode = {
    [ServiceCode.OSASO]: {
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.osasoV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.osasoV1AddFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.osasoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.osasoV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.osasoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.osasoV1EditFinalProcedureDiagnosticReport,
            },
        },
    },
    [ServiceCode.OSASVO]: {
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.osasvoV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.osasvoV1AddFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.osasvoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.osasvoV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.osasvoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.osasvoV1EditFinalProcedureDiagnosticReport,
            },
        },
    },
    [ServiceCode.TPO]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.tpoV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tpoV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tpoV1AddDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tpoV1AddDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1AddFinalProcedureWithRequest,
            },
        },

        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.tpoV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tpoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tpoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tpoV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tpoV1EditFinalProcedure,
            },
        },
    },
    [ServiceCode.TCOR]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.tcorV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tcorV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcorV1AddDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcorV1AddDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1AddFinalProcedureWithRequest,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.tcorV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tcorV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcorV1EditDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1EditFinalProcedureDiagnosticReportWithRequest,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcorV1EditDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcorV1EditFinalProcedureWithRequest,
            },
        },
    },
    [ServiceCode.TCOH]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.tcohV1AddDraftProcedure,
                2: ProcedureValidationTypes.tcohV2AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1AddFinalProcedure,
                2: ProcedureValidationTypes.tcohV2AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tcohV1AddDraftProcedureDiagnosticReport,
                2: ProcedureValidationTypes.tcohV2AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1AddFinalProcedureDiagnosticReport,
                2: ProcedureValidationTypes.tcohV2AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcohV1AddDraftProcedureDiagnosticReportWithRequest,
                2: ProcedureValidationTypes.tcohV2AddDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1AddFinalProcedureDiagnosticReportWithRequest,
                2: ProcedureValidationTypes.tcohV2AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcohV1AddDraftProcedureWithRequest,
                2: ProcedureValidationTypes.tcohV2AddDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1AddFinalProcedureWithRequest,
                2: ProcedureValidationTypes.tcohV2AddFinalProcedureWithRequest,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.tcohV1EditDraftProcedure,
                2: ProcedureValidationTypes.tcohV2EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1EditFinalProcedure,
                2: ProcedureValidationTypes.tcohV2EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tcohV1EditDraftProcedureDiagnosticReport,
                2: ProcedureValidationTypes.tcohV2EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1EditFinalProcedureDiagnosticReport,
                2: ProcedureValidationTypes.tcohV2EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcohV1EditDraftProcedureDiagnosticReportWithRequest,
                2: ProcedureValidationTypes.tcohV2EditDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1EditFinalProcedureDiagnosticReportWithRequest,
                2: ProcedureValidationTypes.tcohV2EditFinalProcedureDiagnosticReportWithRequest,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tcohV1EditDraftProcedureWithRequest,
                2: ProcedureValidationTypes.tcohV2EditDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tcohV1EditFinalProcedureWithRequest,
                2: ProcedureValidationTypes.tcohV2EditFinalProcedureWithRequest,
            },
        },
    },
    [ServiceCode.TIECG]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1AddDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1AddDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1AddFinalProcedureWithRequest,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tiecgV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tiecgV1EditFinalProcedure,
            },
        },
    },
    [ServiceCode.TFO]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.tfoV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tfoV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tfoV1AddDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tfoV1AddDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1AddFinalProcedureWithRequest,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.tfoV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tfoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tfoV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tfoV1EditDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.tfoV1EditFinalProcedureWithRequest,
            },
        },
    },
    [ServiceCode.TOO]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.tooV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tooV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tooV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tooV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tooV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tooV1AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tooV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tooV1AddFinalProcedureWithRequest,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.tooV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tooV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.tooV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tooV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tooV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.tooV1EditFinalProcedureDiagnosticReportWithRequest,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.tooV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.tooV1EditFinalProcedureWithRequest,
            },
        },
    },
    [ServiceCode.PILOT]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1AddDraftProcedureDiagnosticReportWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1AddDraftProcedureWithRequest,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1AddFinalProcedureWithRequest,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.pilotExaminationV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.pilotExaminationV1EditFinalProcedure,
            },
        },
    },
    [ServiceCode.GTO]: {
        addProcedure: {
            final: {
                1: ProcedureValidationTypes.gtoV1AddFinalProcedure,
            },
        },
    },
    [ServiceCode.DermaOth]: {
        addProcedure: {
            final: {
                1: ProcedureValidationTypes.dermaOthV1AddFinalProcedure,
            },
        },
    },
    [ServiceCode.OrthO]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.orthOV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.orthOV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1AddFinalProcedureDiagnosticReportWithRequest,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1AddFinalProcedure,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.orthOV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.orthOV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1EditFinalProcedureDiagnosticReportWithRequest,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOV1EditFinalProcedure,
            },
        },
    },
    [ServiceCode.OrthOFol]: {
        addProcedure: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1AddFinalProcedure,
            },
        },
        addProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1AddFinalProcedureDiagnosticReport,
            },
        },
        addProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1AddDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1AddFinalProcedure,
            },
        },
        editProcedure: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1EditFinalProcedure,
            },
        },
        editProcedureDiagnosticReport: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1EditFinalProcedureDiagnosticReport,
            },
        },
        editProcedureWithRequest: {
            draft: {
                1: ProcedureValidationTypes.orthOFolV1EditDraftProcedure,
            },
            final: {
                1: ProcedureValidationTypes.orthOFolV1EditFinalProcedure,
            },
        },
    },
    [ServiceCode.OORK]: {
        addProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.oorkV1AddDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.oorkV1AddFinalProcedureDiagnosticReport,
            },
        },
        editProcedureDiagnosticReportWithRequest: {
            draft: {
                1: ProcedureValidationTypes.oorkV1EditDraftProcedureDiagnosticReport,
            },
            final: {
                1: ProcedureValidationTypes.oorkV1EditFinalProcedureDiagnosticReport,
            },
        },
    },
};

export function getProcedureValidationType(
    serviceCode: ServiceCode,
    version: number,
    addOrEdit: AddOrEditType,
    draftOrFinal: DraftOrFinalType
) {
    return get(procedureValidationTypes, [serviceCode, addOrEdit, draftOrFinal, version]) as ProcedureValidationTypes;
}
